module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-38.1c70392e.png";